import { computed } from 'vue';

import { AccountsService } from '@/services/accounts.service';
import { useAccountStore } from '@/stores/account';
import { useI18n } from 'vue-i18n';
import { useFormat } from './format';

export const useFetchAccount = () => {
  const accountsService = new AccountsService();

  const accountStore = useAccountStore();
  const { formatError } = useFormat();
  const { t } = useI18n();

  const loading = computed(() => accountStore.loading);
  const error = computed(() => accountStore.error);

  /**
   * Fetch account details for a given account ID
   * @param accountId - The account ID to fetch details for
   */
  const fetchAccountDetails = async (accountId: string) => {
    accountStore.setLoading(true);
    accountStore.setError(null);

    try {
      const response = await accountsService.getAccountDetails(accountId);

      if (!response.model) {
        const errorMessage = 'Account details not found';
        accountStore.setError(errorMessage);
        throw new Error(formatError(response.errors) || t('validation.account_not_found'));
      }

      accountStore.setAccountDetails(response.model);
    } finally {
      accountStore.setLoading(false);
    }
  };

  /**
   * Reset the entire account store
   */
  const resetAccountStore = () => {
    accountStore.reset();
  };

  return {
    loading,
    error,
    fetchAccountDetails,
    resetAccountStore,
  };
};
